/**
 * The PostHog session id rides on every dialer request as `X-PostHog-Session-Id`,
 * so a backend log line, a PostHog replay and an error can be matched up. The
 * backend checks the same pattern; each hop drops anything that doesn't match.
 * No posthog-js import here — server routes use this too.
 */
export const POSTHOG_SESSION_HEADER = "X-PostHog-Session-Id";

const POSTHOG_SESSION_ID_RE = /^[A-Za-z0-9-]{8,64}$/;

export function validPosthogSessionId(value: string | null | undefined): string | null {
  const v = value?.trim();
  return v && POSTHOG_SESSION_ID_RE.test(v) ? v : null;
}
